export default __webpack_public_path__ + "static/media/arrow-left.03a42770.svg";